import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { Toaster } from "sonner";
import LenisProvider from "@/lib/LenisProvider";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import AnnouncementBar from "@/components/layout/AnnouncementBar";
import PageTransition from "@/components/motion/PageTransition";
import Cursor from "@/components/motion/Cursor";
import ScrollProgress from "@/components/motion/ScrollProgress";
import Home from "@/pages/Home";
import Underbloom from "@/pages/Underbloom";
import Fragrance from "@/pages/Fragrance";
import Story from "@/pages/Story";
import Journal from "@/pages/Journal";
import JournalPost from "@/pages/JournalPost";
import ShapeHouse from "@/pages/ShapeHouse";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import ThankYou from "@/pages/ThankYou";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

const withTransition = (el) => <PageTransition>{el}</PageTransition>;

function AnimatedRoutes() {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait" initial={false}>
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={withTransition(<Home />)} />
        <Route path="/underbloom" element={withTransition(<Underbloom />)} />
        <Route path="/fragrance" element={withTransition(<Fragrance />)} />
        <Route path="/story" element={withTransition(<Story />)} />
        <Route path="/journal" element={withTransition(<Journal />)} />
        <Route path="/journal/:slug" element={withTransition(<JournalPost />)} />
        <Route path="/shape-the-house" element={withTransition(<ShapeHouse />)} />
        <Route path="/contact" element={withTransition(<Contact />)} />
        <Route path="/legal/:doc" element={withTransition(<Legal />)} />
        <Route path="/thank-you" element={withTransition(<ThankYou />)} />
        <Route path="*" element={withTransition(<Home />)} />
      </Routes>
    </AnimatePresence>
  );
}

function Shell() {
  return (
    <div className="min-h-screen bg-ivory text-ink">
      <AnnouncementBar />
      <Header />
      <main data-testid="main-content">
        <AnimatedRoutes />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LenisProvider>
          <ScrollToTop />
          <ScrollProgress />
          <Cursor />
          <Shell />
          <Toaster
            position="bottom-center"
            toastOptions={{
              style: {
                background: "#151310",
                color: "#F3F2EC",
                border: "1px solid #151310",
                borderRadius: 0,
                fontFamily: "Inter, sans-serif",
                letterSpacing: "0.05em",
              },
            }}
          />
        </LenisProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
